import { openToast } from "@redux/toast/actions";
import { all, call, put, takeLatest } from "redux-saga/effects";

import { 
    fetchAccountFailure, 
    fetchAccountSuccess,
    setAccountSuccess, 
} from "./actions";

import { 
    FETCH_LOGIN_REQUEST, 
    SET_ACCOUNT_REQUEST,
} from "./actionTypes";
import baseApi from "./api";

function* setAccountSaga(): any {
    try {
        const response = yield call(
            baseApi.setAccount,
        );
        yield put(
            setAccountSuccess({
                account: [],
                result: response.result,
            }),
        );
    } catch (e) {
        console.log(e)
        yield put(
            fetchAccountFailure({
                error: "",
            }),
        );
    }
}

function* fetchLoginSaga({ body ,callback} : any): any {
    try {
        const response = yield call(
            baseApi.login, body
        );

        yield put(
            fetchAccountSuccess({
                account: response,
            })
        )
        yield call(callback)
        yield put(openToast({
                    severity:"success",
                    text: "Login success",
                    open: true
        })) 
    } catch (e) {
        console.log(e)
        yield put(
            fetchAccountFailure({
                error: "",
            }), 
        );
        yield put(openToast({
            severity:"error",
            text: "Email or Password is incorrect, please try again",
            open: true
})) 
    }
}

/*
  Starts worker saga on latest dispatched `FETCH_TODO_REQUEST` action.
  Allows concurrent increments.
*/  
function* toAccountSaga() {
    yield all([takeLatest(FETCH_LOGIN_REQUEST, fetchLoginSaga)]);
    yield all([takeLatest(SET_ACCOUNT_REQUEST, setAccountSaga)])
}

export default toAccountSaga;
